export const state = {
  mountingCurtains: '',
  mountingRoll: '',
  blackout: '',
  hangingCurtains: '',
  mountingCurtains2: '',
  mountingRoll2: '',
  blackout2: '',
  hangingCurtains2: '',
  mountingCurtains3: '',
  mountingRoll3: '',
  blackout3: '',
  hangingCurtains3: '',
  mountingCurtains4: '',
  mountingRoll4: '',
  blackout4: '',
  hangingCurtains4: '',
  mountingCurtains5: '',
  mountingRoll5: '',
  blackout5: '',
  hangingCurtains5: '',
  mountingCurtains6: '',
  mountingRoll6: '',
  blackout6: '',
  hangingCurtains6: '',
  //
  costAdd1: null,
  costAdd2: null,
  costAdd3: null,
  costAdd4: null,
  costAdd5: null,
  costAdd6: null,
  //
  costMountingCurtains1: null,
  costMountingRoll1: null,
  costBlackout1: null,
  costHangingCurtains1: null,
  //
  costMountingCurtains2: null,
  costMountingRoll2: null,
  costBlackout2: null,
  costHangingCurtains2: null,
  //
  costMountingCurtains3: null,
  costMountingRoll3: null,
  costBlackout3: null,
  costHangingCurtains3: null,
  //
  costMountingCurtains4: null,
  costMountingRoll4: null,
  costBlackout4: null,
  costHangingCurtains4: null,
  //
  costMountingCurtains5: null,
  costMountingRoll5: null,
  costBlackout5: null,
  costHangingCurtains5: null,
  //
  costMountingCurtains6: null,
  costMountingRoll6: null,
  costBlackout6: null,
  costHangingCurtains6: null
}

export const getters = {

}

export const mutations = {
  updateCost1Add (state) {
    state.costAdd1 = state.costMountingCurtains1 + state.costMountingRoll1 + state.costBlackout1 + state.costHangingCurtains1
  },
  updateMountingCurtains1 (state) {
    if (state.mountingCurtains) {
      state.costMountingCurtains1 = 1000
    } else {
      state.costMountingCurtains1 = null
    }
  },
  updateMountingRoll1 (state) {
    if (state.mountingRoll) {
      state.costMountingRoll1 = 600
    } else {
      state.costMountingRoll1 = null
    }
  },
  updateBlackout1 (state) {
    if (state.blackout) {
      state.costBlackout1 = 700
    } else {
      state.costBlackout1 = null
    }
  },
  updateBlackout1withErker (state) {
    if (this.state.Window1.widthWindow1 > 2500) {
      state.costBlackout1 = state.costBlackout1 + (state.costBlackout1 * 0.35)
    }
  },
  updateHangingCurtains1 (state) {
    if (state.hangingCurtains) {
      state.costHangingCurtains1 = 500
    } else {
      state.costHangingCurtains1 = null
    }
  },
  // 2
  updateCost2Add (state) {
    state.costAdd2 = state.costMountingCurtains2 + state.costMountingRoll2 + state.costBlackout2 + state.costHangingCurtains2
  },
  updateMountingCurtains2Method (state) {
    if (state.mountingCurtains2) {
      state.costMountingCurtains2 = 1000
    } else {
      state.costMountingCurtains2 = null
    }
  },
  updateMountingRoll2Method (state) {
    if (state.mountingRoll2) {
      state.costMountingRoll2 = 600
    } else {
      state.costMountingRoll2 = null
    }
  },
  updateBlackout2Method (state) {
    if (state.blackout2) {
      state.costBlackout2 = 700
    } else {
      state.costBlackout2 = null
    }
  },
  updateBlackout2withErker (state) {
    if (this.state.Window2.widthWindow2 > 2500) {
      state.costBlackout2 = state.costBlackout2 + (state.costBlackout2 * 0.35)
    }
  },
  updateHangingCurtains2Method (state) {
    if (state.hangingCurtains2) {
      state.costHangingCurtains2 = 500
    } else {
      state.costHangingCurtains2 = null
    }
  },
  // 3
  updateCost3Add (state) {
    state.costAdd3 = state.costMountingCurtains3 + state.costMountingRoll3 + state.costBlackout3 + state.costHangingCurtains3
  },
  updateMountingCurtains3Method (state) {
    if (state.mountingCurtains3) {
      state.costMountingCurtains3 = 1000
    } else {
      state.costMountingCurtains3 = null
    }
  },
  updateMountingRoll3Method (state) {
    if (state.mountingRoll3) {
      state.costMountingRoll3 = 600
    } else {
      state.costMountingRoll3 = null
    }
  },
  updateBlackout3Method (state) {
    if (state.blackout3) {
      state.costBlackout3 = 700
    } else {
      state.costBlackout3 = null
    }
  },
  updateBlackout3withErker (state) {
    if (this.state.Window3.widthWindow3 > 2500) {
      state.costBlackout3 = state.costBlackout3 + (state.costBlackout3 * 0.35)
    }
  },
  updateHangingCurtains3Method (state) {
    if (state.hangingCurtains3) {
      state.costHangingCurtains3 = 500
    } else {
      state.costHangingCurtains3 = null
    }
  },
  // 4
  updateCost4Add (state) {
    state.costAdd4 = state.costMountingCurtains4 + state.costMountingRoll4 + state.costBlackout4 + state.costHangingCurtains4
  },
  updateMountingCurtains4Method (state) {
    if (state.mountingCurtains4) {
      state.costMountingCurtains4 = 1000
    } else {
      state.costMountingCurtains4 = null
    }
  },
  updateMountingRoll4Method (state) {
    if (state.mountingRoll4) {
      state.costMountingRoll4 = 600
    } else {
      state.costMountingRoll4 = null
    }
  },
  updateBlackout4Method (state) {
    if (state.blackout4) {
      state.costBlackout4 = 700
    } else {
      state.costBlackout4 = null
    }
  },
  updateBlackout4withErker (state) {
    if (this.state.Window4.widthWindow4 > 2500) {
      state.costBlackout4 = state.costBlackout4 + (state.costBlackout4 * 0.35)
    }
  },
  updateHangingCurtains4Method (state) {
    if (state.hangingCurtains4) {
      state.costHangingCurtains4 = 500
    } else {
      state.costHangingCurtains4 = null
    }
  },
  // 5
  updateCost5Add (state) {
    state.costAdd5 = state.costMountingCurtains5 + state.costMountingRoll5 + state.costBlackout5 + state.costHangingCurtains5
  },
  updateMountingCurtains5Method (state) {
    if (state.mountingCurtains5) {
      state.costMountingCurtains5 = 1000
    } else {
      state.costMountingCurtains5 = null
    }
  },
  updateMountingRoll5Method (state) {
    if (state.mountingRoll5) {
      state.costMountingRoll5 = 600
    } else {
      state.costMountingRoll5 = null
    }
  },
  updateBlackout5Method (state) {
    if (state.blackout5) {
      state.costBlackout5 = 700
    } else {
      state.costBlackout5 = null
    }
  },
  updateBlackout5withErker (state) {
    if (this.state.Window5.widthWindow5 > 2500) {
      state.costBlackout5 = state.costBlackout5 + (state.costBlackout5 * 0.35)
    }
  },
  updateHangingCurtains5Method (state) {
    if (state.hangingCurtains5) {
      state.costHangingCurtains5 = 500
    } else {
      state.costHangingCurtains5 = null
    }
  },
  // 6
  updateCost6Add (state) {
    state.costAdd6 = state.costMountingCurtains6 + state.costMountingRoll6 + state.costBlackout6 + state.costHangingCurtains6
  },
  updateMountingCurtains6Method (state) {
    if (state.mountingCurtains6) {
      state.costMountingCurtains6 = 1000
    } else {
      state.costMountingCurtains6 = null
    }
  },
  updateMountingRoll6Method (state) {
    if (state.mountingRoll6) {
      state.costMountingRoll6 = 600
    } else {
      state.costMountingRoll6 = null
    }
  },
  updateBlackout6Method (state) {
    if (state.blackout6) {
      state.costBlackout6 = 700
    } else {
      state.costBlackout6 = null
    }
  },
  updateBlackout6withErker (state) {
    if (this.state.Window6.widthWindow6 > 2500) {
      state.costBlackout6 = state.costBlackout6 + (state.costBlackout6 * 0.35)
    }
  },
  updateHangingCurtains6Method (state) {
    if (state.hangingCurtains6) {
      state.costHangingCurtains6 = 500
    } else {
      state.costHangingCurtains6 = null
    }
  },
  updateMountingCurtains (state, mountingCurtains) {
    state.mountingCurtains = mountingCurtains
  },
  updateMountingRoll (state, mountingRoll) {
    state.mountingRoll = mountingRoll
  },
  updateBlackout (state, blackout) {
    state.blackout = blackout
  },
  updateHangingCurtains (state, hangingCurtains) {
    state.hangingCurtains = hangingCurtains
  },
  updateMountingCurtains2 (state, mountingCurtains2) {
    state.mountingCurtains2 = mountingCurtains2
  },
  updateMountingRoll2 (state, mountingRoll2) {
    state.mountingRoll2 = mountingRoll2
  },
  updateBlackout2 (state, blackout2) {
    state.blackout2 = blackout2
  },
  updateHangingCurtains2 (state, hangingCurtains2) {
    state.hangingCurtains2 = hangingCurtains2
  },
  updateMountingCurtains3 (state, mountingCurtains3) {
    state.mountingCurtains3 = mountingCurtains3
  },
  updateMountingRoll3 (state, mountingRoll3) {
    state.mountingRoll3 = mountingRoll3
  },
  updateBlackout3 (state, blackout3) {
    state.blackout3 = blackout3
  },
  updateHangingCurtains3 (state, hangingCurtains3) {
    state.hangingCurtains3 = hangingCurtains3
  },
  updateMountingCurtains4 (state, mountingCurtains4) {
    state.mountingCurtains4 = mountingCurtains4
  },
  updateMountingRoll4 (state, mountingRoll4) {
    state.mountingRoll4 = mountingRoll4
  },
  updateBlackout4 (state, blackout4) {
    state.blackout4 = blackout4
  },
  updateHangingCurtains4 (state, hangingCurtains4) {
    state.hangingCurtains4 = hangingCurtains4
  },
  updateMountingCurtains5 (state, mountingCurtains5) {
    state.mountingCurtains5 = mountingCurtains5
  },
  updateMountingRoll5 (state, mountingRoll5) {
    state.mountingRoll5 = mountingRoll5
  },
  updateBlackout5 (state, blackout5) {
    state.blackout5 = blackout5
  },
  updateHangingCurtains5 (state, hangingCurtains5) {
    state.hangingCurtains5 = hangingCurtains5
  },
  updateMountingCurtains6 (state, mountingCurtains6) {
    state.mountingCurtains6 = mountingCurtains6
  },
  updateMountingRoll6 (state, mountingRoll6) {
    state.mountingRoll6 = mountingRoll6
  },
  updateBlackout6 (state, blackout6) {
    state.blackout6 = blackout6
  },
  updateHangingCurtains6 (state, hangingCurtains6) {
    state.hangingCurtains6 = hangingCurtains6
  }
}

export const actions = {
}

export default {
  state,
  getters,
  mutations,
  actions
}
